import { render, staticRenderFns } from "./SlotSoftwareTypeForm.vue?vue&type=template&id=24db876c&"
import script from "./SlotSoftwareTypeForm.vue?vue&type=script&lang=js&"
export * from "./SlotSoftwareTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports